'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CKEditor = function (_Component) {
    (0, _inherits3["default"])(CKEditor, _Component);

    function CKEditor(props) {
        (0, _classCallCheck3["default"])(this, CKEditor);

        var _this = (0, _possibleConstructorReturn3["default"])(this, _Component.call(this, props));

        _this.state = {
            value: props.value,
            config: props.config || {},
            onChange: props.onChange
        };
        return _this;
    }

    CKEditor.prototype.handleChange = function handleChange() {
        this.state.onChange(this.state.value);
    };

    CKEditor.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        if (!window.CKEDITOR) {
            console.error('CKEditor not found');
            return;
        }

        this.instance = window.CKEDITOR.appendTo(_reactDom2["default"].findDOMNode(this), this.state.config, this.state.value);
        this.instance.on('change', function () {
            _this2.state.value = _this2.instance.getData();
            _this2.handleChange();
        });
    };

    CKEditor.prototype.componentDidUpdate = function componentDidUpdate() {
        console.log('updating', this.state);
    };

    CKEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (!this.instance) {
            return;
        }

        if (this.state.value !== props.value) {
            // setData will move the cursor to the begining of the input
            this.instance.setData(props.value);
        }

        this.setState({
            value: props.value,
            config: props.config || {},
            onChange: props.onChange
        });
    };

    CKEditor.prototype.render = function render() {
        return _react2["default"].createElement('div', null);
    };

    return CKEditor;
}(_react.Component);

exports["default"] = CKEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-ckeditor-wrapper/lib/ckeditor.js
// module id = 328
// module chunks = 0